export default "__VITE_ASSET__BtoJiqMR__"